declare var window: {
    dataLayer: any[]
}

export function trackEvent(
    category: string,
    action?: string,
    label?: string,
    value?: any
) {
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label,
            'eventValue': value
        });
    }
}